import { render, staticRenderFns } from "./SlotManagement.vue?vue&type=template&id=34836fff&scoped=true&"
import script from "./SlotManagement.vue?vue&type=script&lang=js&"
export * from "./SlotManagement.vue?vue&type=script&lang=js&"
import style0 from "./SlotManagement.vue?vue&type=style&index=0&id=34836fff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34836fff",
  null
  
)

export default component.exports